import type { LeagueBattingStatRow, LeaguePitchingStatRow, PlayerCareerStatRow } from '@/api/generated/models'
import type { StatLine } from '../types'

/** Never coerce null to 0 — null means "not applicable / not recorded". */
function n(v: number | null | undefined): number | undefined {
  return v == null ? undefined : v
}

function teamLabel(city?: string | null, name?: string | null): string | undefined {
  const parts = [city, name].filter(Boolean)
  return parts.length ? parts.join(' ') : undefined
}

export function mapBattingLine(r: LeagueBattingStatRow, label?: string): StatLine {
  return {
    label: label ?? (r.year != null ? String(r.year) : undefined),
    teamId: n(r.teamId),
    team: teamLabel(r.city, r.name),
    g: n(r.sg),
    ab: n(r.sab),
    r: n(r.sr),
    h: n(r.sh),
    doubles: n(r.s2b),
    triples: n(r.s3b),
    hr: n(r.shr),
    rbi: n(r.srbi),
    bb: n(r.sbb),
    so: n(r.sso),
    sb: n(r.ssb),
    cs: n(r.scs),
    avg: n(r.savg),
    obp: n(r.sobp),
    slg: n(r.sslg),
    ops: n(r.sops),
  }
}

export function mapPitchingLine(r: LeaguePitchingStatRow, label?: string): StatLine {
  return {
    label: label ?? (r.year != null ? String(r.year) : undefined),
    teamId: n(r.teamId),
    team: teamLabel(r.city, r.name),
    g: n(r.sg),
    gs: n(r.sgs),
    w: n(r.sw),
    l: n(r.sl),
    sv: n(r.ssv),
    ip: n(r.sip),
    h: n(r.sh),
    r: n(r.sr),
    er: n(r.ser),
    bb: n(r.sbb),
    so: n(r.sso),
    era: n(r.sera),
    whip: n(r.swhip),
  }
}

export function mapCareerRow(r: PlayerCareerStatRow, isPitcher: boolean, label?: string): StatLine {
  // PlayerCareerStatRow shares the same s-prefixed field names as the league rows.
  // Cast to the appropriate row type and delegate.
  if (isPitcher) {
    return mapPitchingLine(r as unknown as LeaguePitchingStatRow, label)
  }
  return mapBattingLine(r as unknown as LeagueBattingStatRow, label)
}
